import { useEffect } from "react";
import { FormattedMessage } from "react-intl";

import UsageDashboard from "../../../../components/usage/dashboard";
import { Settings, User } from "../../../../interfaces";

const Usage: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  useEffect(() => {
    props.onRequestSettings();
  }, []);

  return (
    <div className="settings-presentation settings-w-presentation">
      <h4>
        <FormattedMessage id="usage.title" />
      </h4>
      <p className="color-step-700 fs-3">
        <FormattedMessage id="usage.subTitle" />
      </p>
      <hr />
      <UsageDashboard />
    </div>
  );
};

interface ILayoutProps {
  settings: Settings;
  user: User;
  onRequestSettings: Function;
}

export default Usage;
